import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Texture, BaseTexture } from '@pixi/core';
import '../utils/index.mjs';
import { convertToList } from '../utils/convertToList.mjs';
var CacheClass = /*#__PURE__*/function () {
  function CacheClass() {
    _classCallCheck(this, CacheClass);
    this._parsers = [];
    this._cache = /* @__PURE__ */new Map();
    this._cacheMap = /* @__PURE__ */new Map();
  }
  _createClass(CacheClass, [{
    key: "reset",
    value: function reset() {
      this._cacheMap.clear();
      this._cache.clear();
    }
  }, {
    key: "has",
    value: function has(key) {
      return this._cache.has(key);
    }
  }, {
    key: "get",
    value: function get(key) {
      var result = this._cache.get(key);
      if (!result) {
        console.warn("[Assets] Asset id ".concat(key, " was not found in the Cache"));
      }
      return result;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var _this = this;
      var keys = convertToList(key);
      var cacheableAssets;
      for (var i = 0; i < this.parsers.length; i++) {
        var parser = this.parsers[i];
        if (parser.test(value)) {
          cacheableAssets = parser.getCacheableAssets(keys, value);
          break;
        }
      }
      if (!cacheableAssets) {
        cacheableAssets = {};
        keys.forEach(function (key2) {
          cacheableAssets[key2] = value;
        });
      }
      var cacheKeys = Object.keys(cacheableAssets);
      var cachedAssets = {
        cacheKeys: cacheKeys,
        keys: keys
      };
      keys.forEach(function (key2) {
        _this._cacheMap.set(key2, cachedAssets);
      });
      cacheKeys.forEach(function (key2) {
        if (_this._cache.has(key2) && _this._cache.get(key2) !== value) {
          console.warn("[Cache] already has key:", key2);
        }
        _this._cache.set(key2, cacheableAssets[key2]);
      });
      if (value instanceof Texture) {
        var texture = value;
        keys.forEach(function (key2) {
          if (texture.baseTexture !== Texture.EMPTY.baseTexture) {
            BaseTexture.addToCache(texture.baseTexture, key2);
          }
          Texture.addToCache(texture, key2);
        });
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var _this2 = this;
      this._cacheMap.get(key);
      if (!this._cacheMap.has(key)) {
        console.warn("[Assets] Asset id ".concat(key, " was not found in the Cache"));
        return;
      }
      var cacheMap = this._cacheMap.get(key);
      var cacheKeys = cacheMap.cacheKeys;
      cacheKeys.forEach(function (key2) {
        _this2._cache.delete(key2);
      });
      cacheMap.keys.forEach(function (key2) {
        _this2._cacheMap.delete(key2);
      });
    }
  }, {
    key: "parsers",
    get: function get() {
      return this._parsers;
    }
  }]);
  return CacheClass;
}();
var Cache = new CacheClass();
export { Cache };